import * as React from "react"

const SvgDeviceTablet = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 23.571q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 21.57v-18q0-.824.587-1.412A1.93 1.93 0 0 1 5 1.57h14q.824 0 1.413.588Q21 2.745 21 3.57v18a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 19 23.57H5Zm0-3v1h14v-1zm0-2h14v-12H5zm0-14h14v-1H5z" />
  </svg>
)
export default SvgDeviceTablet
